<template>
  <div class="button-block flex flex-col space-y-4">
    <lf-input
      :value="modelValue.text ?? ''"
      name="button-text"
      :placeholder="t('BORROWER_PLATFORM.BUTTON_TEXT')"
      :disabled="disabled"
      data-cy="button-text-input"
      @key-released="handleStateFieldUpdate('text', $event as string)"
    />

    <lf-input
      :value="modelValue.url ?? ''"
      name="redirect-link"
      :placeholder="t('BORROWER_PLATFORM.REDIRECT_LINK')"
      :disabled="disabled"
      data-cy="redirect-link-input"
      @key-released="handleStateFieldUpdate('url', $event as string)"
    />
  </div>
</template>

<script setup lang="ts">
import { toRef } from "vue";
import { useI18n } from "vue-i18n";

import { useBlockEdit } from "@/composables/useBlockEdit";

import type { BaseBlockProps } from "@/models/borrowerPlatformTemplates";
import type { Block } from "@/models/borrowerPlatformTemplates";

const { modelValue, disabled = false } = defineProps<
  BaseBlockProps & {
    disabled?: boolean;
  }
>();

const { t } = useI18n();
const { updateBlock } = useBlockEdit(toRef(() => modelValue));

const handleStateFieldUpdate = (field: string, value: string) => {
  updateBlock(field as keyof Block, value);
};
</script>
